import PortalReactDOM from 'react-dom'
import {
  Backdrop,
  CircularProgress,
  Dialog,
  Stack,
  Typography,
  useTheme
} from '@mui/material'
import colors from 'styles/colors'
import CircularProgressBar from 'components/atoms/CircularProgressBar'

const OverlayLoading = ({ open }) => {
  return (
    <>
      {open ? (
        <>
          {PortalReactDOM.createPortal(
            <Backdrop
              sx={{
                color: '#fff',
                zIndex: theme =>
                  Math.max.apply(Math, Object.values(theme.zIndex)) + 1
              }}
              data-testid='overlayer-spinner'
              open={open}>
              <CircularProgress color='inherit' />
            </Backdrop>,
            document.body
          )}
        </>
      ) : null}
    </>
  )
}

export const OverlayWithText = ({
  isOpen,
  title,
  message,
  progress = null
}) => {
  const theme = useTheme()
  const dialogStyles = {
    '& .MuiDialog-paper': {
      backgroundColor:
        theme.palette.background.yellow || theme.palette.background.paper
    }
  }
  return (
    <Dialog open={isOpen} maxWidth='xs' sx={dialogStyles}>
      <Stack alignItems='center' spacing={10} padding={12}>
        {progress !== null ? (
          <CircularProgressBar
            value={progress}
            useGradientArch={true}
            emptyArchColor={colors.MutedTeal50}
            backgroundColor={colors.White}
          />
        ) : (
          <CircularProgress />
        )}

        {title && (
          <Typography variant='h2' textAlign='center'>
            {title}
          </Typography>
        )}
        <Typography variant='h5' fontWeight={400} textAlign='center'>
          {message}
        </Typography>
      </Stack>
    </Dialog>
  )
}

export default OverlayLoading
